import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { PreparingDeliveryOrderTemplate } from 'components/Templates'

const PreparingDeliveryOrder: FC = () => {
  return (
    <Layout
      headline={'未発送の注文を確認する'}
      iconPath={'/icon/white/schedule.svg'}
      headlineSize={'small'}
      title={'未発送の注文を確認する'}
    >
      <PreparingDeliveryOrderTemplate />
    </Layout>
  )
}

export default PreparingDeliveryOrder
